
class UtilClass {
    getRandomNumber() {
        let random = Math.random() * 8888 + 1000
        return Math.floor(random);
    }

    calculateElapsedTime = (from, till = moment()) => {
        const elapsedSecond = till.diff(from, 'second')
        const elapsedMinute = till.diff(from, 'minute')
        const hms = this.durationToHms(elapsedSecond, 'second')
        return {
            elapsedSecond, elapsedMinute, hms,
        }
    }

    durationToHms = (duration, durationUnit = 'second') => {
        // First convert duration to 'second'
        if (durationUnit == 'second') {
            duration = duration
        }
        else if (durationUnit == 'minute') {
            duration = duration * 60
        }
        else if (durationUnit == 'hour') {
            duration = duration * 3600
        }
        else if (durationUnit == 'milisecond') {
            duration = duration / 1000
        }
        const hour = Math.floor(duration / 3600)
        const minute = Math.floor((duration % 3600) / 60)
        const second = duration % 60
        let hms = `${hour ? `${hour}:` : ""}${(minute+"").padStart("2", "0")}:${(second+"").padStart("2", "0")}`
        return hms
    }
}

var Util = new UtilClass;
export default Util;